import type { Theme } from '@mui/material';
import { Box, Divider as MUIDivider, useMediaQuery } from '@mui/material';
import type { FC } from 'react';
import type { DividerProps } from './Divider.types';

const DIVIDER_WIDTHS = {
  mobile: { small: '40%', medium: '60%', large: '100%' },
  desktop: { small: '25%', medium: '50%', large: '100%' },
};

export const Divider: FC<DividerProps> = ({ size }) => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
  const width = DIVIDER_WIDTHS[isMobile ? 'mobile' : 'desktop'][size];

  return (
    <Box display="flex" justifyContent="center">
      <MUIDivider sx={{ width }} />
    </Box>
  );
};
